// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8qhwd","image":"Header_image__Zz_-7","name":"Header_name__3fNFS","info":"Header_info__3tkzk","infoRow":"Header_infoRow__fOvgk"};